import type {RenderedInvitation} from '../config/invitationEmail';
export async function copyInvitation(email:RenderedInvitation,formatted=false){
 if(!navigator.clipboard)throw new Error('Clipboard unavailable. Select and copy the plain-text email below.');
 if(formatted&&typeof ClipboardItem!=='undefined'&&navigator.clipboard.write){
  try{await navigator.clipboard.write([new ClipboardItem({'text/html':new Blob([email.html],{type:'text/html'}),'text/plain':new Blob([email.text],{type:'text/plain'})})]);return 'Formatted email copied. Paste it into your email composer.';}
  catch{/* A browser may permit text while rejecting rich clipboard content. */}
 }
 await navigator.clipboard.writeText(email.text);
 return formatted?'This browser copied plain text. Paste it into your email composer.':'Plain-text email copied.';
}
